import React, { useState, useEffect } from "react";
import { AiOutlineCopy } from "react-icons/ai";
// import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import Card from "../../components/Common/Card";
import ListItem from "../../components/Common/ListItem";
import SettingsIcon from "../../components/Common/SettingsIcon";
import Divider from "../../components/Divider";
import Impact from "../../components/Impact";
import DepositTab from "../../components/Pools/DepositTab";
import WithdrawTab from "../../components/Pools/WithdrawTab";
import { foil_swap_address } from "../../libs/address";
import { getCoinInfo, CoinInfo } from "../../libs/pool";
import {
  get_coin_icon,
  get_coin_short_name,
  get_lp_coin_balance,
} from "../../libs/swap_sdk";
import { useAppSelector } from "../../store/hooks";
import { short_address, short_coin_address } from "../../utils/common";

export default function Pair() {
  const { x, y } = useParams();

  const coinX = x ? x : "";
  const coinY = y ? y : "";

  const coinInfoIconX = get_coin_icon(coinX);
  const coinInfoIconY = get_coin_icon(coinY);
  const [tab, setTab] = useState("deposit");

  const impactRef = React.createRef();
  const [slippageRate, setSlippageRate] = useState("0.1");

  const [lpBalance, setLpBalance] = useState<number>(0);

  const accountAddress = useAppSelector(
    (state: any) => state.wallet.accountAddress
  );

  const [xCoinInfo, setXCoinInfo] = useState<CoinInfo | undefined>(undefined);
  const [yCoinInfo, setYCoinInfo] = useState<CoinInfo | undefined>(undefined);

  useEffect(() => {
    getCoinInfo(coinX).then((res: CoinInfo) => {
      setXCoinInfo(res);
    });
  }, [coinX]);

  useEffect(() => {
    getCoinInfo(coinY).then((res: CoinInfo) => {
      setYCoinInfo(res);
    });
  }, [coinY]);

  useEffect(() => {
    const get = async () => {
      const lp_amount = await get_lp_coin_balance(accountAddress, coinX, coinY);
      setLpBalance(Number(lp_amount));
    };
    if (accountAddress) {
      get();
    }
  }, [coinX, coinY, accountAddress]);

  return (
    <div className="w-2/3 my-0 pt-24 mx-auto pb-3 h-screen no-scrollbar overflow-auto max-lg:w-full max-lg:px-2">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2 border-b border-white pb-3">
          <div className="flex justify-between items-center">
            <p className="text-white">
              {xCoinInfo?.symbol!} - {yCoinInfo?.symbol!} Pool
            </p>
            <div className="flex">
              <img alt="Coin" className="w-8 h-8" src={coinInfoIconX.icon} />
              <img alt="Coin" className="w-8 h-8" src={coinInfoIconY.icon} />
            </div>
          </div>
          <div className="text-white text-end">
            LP Balance: {Number(lpBalance).toFixed(3)}
          </div>
        </div>
        <br />
        <h4 className="text-base text-white">Liquidity Management</h4>
        <Card>
          <div className="flex justify-between items-center py-4 px-4">
            <div className="flex text-white text-base gap-3 font-semibold ">
              <button
                className={`${
                  tab === "deposit"
                    ? "text-white"
                    : "text-white text-opacity-30"
                }`}
                onClick={() => setTab("deposit")}
              >
                Deposit
              </button>
              <button
                className={`${
                  tab === "withdraw"
                    ? "text-white"
                    : "text-white text-opacity-30"
                }`}
                onClick={() => setTab("withdraw")}
              >
                Withdraw
              </button>
            </div>
            <SettingsIcon
              onClick={() => {
                const current: any = impactRef.current;
                current.open();
              }}
            />
          </div>
          <Divider padding={2} />
          <div>
            {tab === "deposit" ? (
              <DepositTab
                slippageRate={slippageRate}
                coinX={coinX}
                coinY={coinY}
              />
            ) : (
              <WithdrawTab
                slippageRate={slippageRate}
                coinX={coinX}
                coinY={coinY}
              />
            )}
          </div>
        </Card>
        <br />
        <h4 className="text-base text-white">Pool Stats</h4>

        <Card>
          <div className="flex flex-col gap-4 p-4">
            <ListItem label="Currency Reserves">
              <div className="flex flex-col gap-2">
                <div className="flex gap-2">
                  <img
                    alt="Coin"
                    className="w-8 h-7"
                    src={coinInfoIconX.icon}
                  />
                  <p />
                </div>
                <div className="flex gap-2">
                  <img
                    alt="Coin"
                    className="w-8 h-7"
                    src={coinInfoIconY.icon}
                  />
                  <p />
                </div>
              </div>
            </ListItem>
            <ListItem label="Total Reserves">
              <div className="flex items-center gap-2">
                <div className="flex">
                  <img
                    alt="Coin"
                    className="w-8 h-8"
                    src={coinInfoIconX.icon}
                  />
                  <img
                    alt="Coin"
                    className="w-8 h-8 -ml-3"
                    src={coinInfoIconY.icon}
                  />
                </div>
              </div>
            </ListItem>
            <Divider padding={2} />
            <ListItem label="Swap Fee">0.01%</ListItem>
            <ListItem label="Withdraw Fee" />
          </div>
        </Card>
        <br />
        <h4 className="text-base text-white"> Account Info</h4>
        <Card>
          <div className="p-4 flex flex-col gap-4">
            <ListItem label="Swap address">
              <p className="text-blue-500">
                {short_address(foil_swap_address)}
              </p>
              <AiOutlineCopy
                className="cursor-pointer"
                onClick={() => navigator.clipboard.writeText(foil_swap_address)}
              />
            </ListItem>
            <ListItem label={`${get_coin_short_name(coinX)} address`}>
              <p className="text-blue-500">{short_coin_address(coinX)}</p>
              <AiOutlineCopy
                className="cursor-pointer"
                onClick={() => navigator.clipboard.writeText(coinX)}
              />
            </ListItem>
            <ListItem label={`${get_coin_short_name(coinY)} address`}>
              <p className="text-blue-500">{short_coin_address(coinY)}</p>
              <AiOutlineCopy
                className="cursor-pointer"
                onClick={() => navigator.clipboard.writeText(coinY)}
              />
            </ListItem>
          </div>
        </Card>
      </div>
      <Impact
        onRef={impactRef}
        slippageRate={slippageRate}
        setSlippageRate={setSlippageRate}
      />
    </div>
  );
}
